// extracted by mini-css-extract-plugin
export default {"tabs":"o9-z","tablist":"p9-z","tablistItem":"q9-z"};